import React, { Component } from "react";
import { connect } from "react-redux";
import * as postActions from "../../../store/action/post";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  renderFormField,
  renderTextAreaField,
  formatPrice,
  normalizePrice,
} from "../../../utils/reduxField";
import * as _ from "lodash";
import { Field, reduxForm, formValueSelector, change } from "redux-form";
import {
  validateCreatePostForm,
  validatePrice,
  validateDiscount,
} from "../../../utils/formValidation";
import CreatorItem from "./creator-item/creator-item";
import { updateLogPostGroup } from "../../../utils/common";
import localStore from "src/utils/local-storage";
import getPrType from "src/utils/prType";
import Select from "react-select";
import { confirmAlert } from "react-confirm-alert"; // Import

const validate = (values) => {
  return validateCreatePostForm(values, false);
};
class PRTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prprice: props.post.currentPost.prprice ? props.post.currentPost.prprice : null,
      prdiscount: props.post.currentPost.prdiscount ? props.post.currentPost.prdiscount : null,
      pragency: props.post.currentPost.pragency ? props.post.currentPost.pragency : null,
      focusPRPrice: "",
      focusPRDiscount: "",
      currentPost: null,
      timer: null,
      timerUpdatePrice: null,
      timerUpdatePriceNoti: null,
      timerUpdateDiscount: null,
      timerUpdateDiscountNoti: null,
      prType: [],
      prSelected: { type: "0", label: "Không phải PR", value: "0" },
      isPr: false,
      logs: null,
    };
  }
  componentDidMount() {
    if (this.state.prprice != 0) {
      // this.updateFieldData({prprice: this.state.prprice}, "prprice");
      this.props.changeFieldValue("prprice", this.state.prprice);
    }
    if (this.state.prdiscount != 0) {
      // this.updateFieldData({prdiscount: this.state.prdiscount}, "prdiscount");
      this.props.changeFieldValue("prdiscount", this.state.prdiscount);
    }
    this.setState({ currentPost: this.props.post.currentPost });
  }
  UNSAFE_componentWillMount() {
    const {
      post: { currentPost },
    } = this.props;
    let { isPr, prType, prSelected, pragency } = this.state;
    const _user = localStore.get("_user");
    const isAdmin = _user.role.name == "SuperAdmin";
    const disablePR = currentPost.publisher ? (isAdmin ? false : true) : false;

    prType = getPrType(disablePR);

    if (currentPost.pr_type) {
      prSelected = _.find(prType, (type) => {
        return type.value == currentPost.pr_type;
      });
    } else {
      currentPost.pr_type = "0";
      this.props.setCurrentPost(currentPost);
    }

    this.setState({ pr_type: currentPost.pr_type, prSelected, prType });
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      post: nextPost,
      fields: nextFields,
      currenttab: nextTab,
      logs: nextLogs,
    } = nextProps;
    const { currentPost } = nextPost;
    let { isPr, prType, prSelected, logs } = this.state;
    if (currentPost.pr_type) {
      prSelected = _.find(prType, (type) => {
        return type.value == currentPost.pr_type;
      });
      if(prSelected && prSelected.value == '0'){
        currentPost.prprice = null;
        currentPost.prdiscount = null;
        currentPost.pragency = null;
      }
    } else {
      currentPost.pr_type = "0";
      currentPost.prprice = null;
      currentPost.prdiscount = null;
      currentPost.pragency = null;
    }
    if(currentPost.pr_type == 0){
      this.props.changeFieldValue("prdiscount", null);
      this.props.changeFieldValue("prprice", null);
    }
    this.props.setCurrentPost(currentPost);
  }
  logsChangePR = (typeLog, valueLog) => {
    const {prSelected, pragency, prprice, prdiscount, logs} = this.state;
    const {
      post: { currentPost },
    } = this.props;
    let selectPRAgency = null;
    if(pragency){
      if(typeof pragency == "object"){
        selectPRAgency = pragency;
      }else{
        selectPRAgency = _.find(this.props.config.listPRAgency, {
          id: pragency,
        });
      }
    }
    if(typeLog == "type"){
      const prTypeSelected =  _.find(this.state.prType, (type) => {
        return type.value == valueLog;
      });
      valueLog = prTypeSelected.label;
    }
    if(!logs){
      const initLogs = {
        type: {
          value: prSelected && prSelected.label ? (typeLog == "type" ? valueLog : prSelected.label) : "Không phải PR",
          label: "loại pr"
        },
        agency: {
          value: selectPRAgency && selectPRAgency.label ? (typeLog == "agency" ? valueLog :  selectPRAgency.label) : "",
          label: "agency"
        },
        price: {
          value: prprice ? formatPrice(prprice) : 0,
          label: "giá"
        },
        discount: {
          value: prdiscount ? prdiscount : 0,
          label: "giảm giá"
        }
      };
      this.setState({
        logs: initLogs
      })
    }
    if(typeLog == "price"){
      valueLog = formatPrice(valueLog);
    }
    if(logs && logs[typeLog].value != valueLog){
      // let prevLogs = this.state.logs;
      // prevLogs[typeLog].value = valueLog;
      // // this.setState({logs: prevLogs});
      this.setState(prevState => {
        let tmpLogs = Object.assign({}, prevState.logs);
        tmpLogs[typeLog].value = valueLog;
        return tmpLogs;
      },() => {
          console.log("change logs");
          const newLogsStr = updateLogPostGroup("set pr:", logs);
          let log_action = `${this.props.post.currentPost.log_action}${newLogsStr}`;
          currentPost.log_action = log_action;
          this.props.setCurrentPost(currentPost);
      })
    }
    // push logs
    // const newLogs = updateLogPostGroup("set pr:", logs)
    // console.log(newLogs);
    // if (newLogs.length) {
    //   const newLogsStr = newLogs.join(",");
    //   let log_action = `${this.props.post.currentPost.log_action}${newLogsStr}`;
    //   currentPost.log_action = log_action;
    // }

  }
  getValuePRType = (value) => {
    let { prType, prSelected } = this.state;
    if (value) {
      prSelected = _.find(prType, (type) => {
        return type.value == value.value;
      });
      const {
        post: { currentPost },
      } = this.props;
      currentPost.pr_type = prSelected.value;
      // khi nào pr price chưa được set thì mới lấy giá default từ báo giá chèn vào ô prprice
      if (
        prSelected.value > 0 &&
        prSelected.prprice &&
        (!currentPost.prprice || currentPost.prprice == 0)
      ) {
        // get default prprice
        currentPost.prprice = prSelected.prprice;
      }
      // ngược lại nếu đã có prprice hiện popup thông báo user có muốn tự động thay đổi giá
      if (
        prSelected.value > 0 &&
        prSelected.prprice &&
        currentPost.prprice &&
        prSelected.prprice != currentPost.prprice
      ) {
        this.confirmActionUpdatePRPrice(prSelected.prprice);
      }

      if(prSelected.value == 0){
        currentPost.prprice = null;
        currentPost.pragency = null;
        currentPost.prdiscount = null;
        currentPost.pr_type = 0;
        this.setState({prprice: null, pragency: null, prdiscount: null});
        this.updateFieldData({prprice: null}, "prprice");
        this.updateFieldData({prdiscount: null}, "prdiscount");
      }
      this.props.setCurrentPost(currentPost);
      this.setState({ prSelected });
      this.logsChangePR("type", prSelected.value);
    }
  };

  changeStatusPR(check) {
    const {
      post: { currentPost },
    } = this.props;
    this.setState({ isPr: check }, () => {
      currentPost.is_pr = check;
      this.props.setCurrentPost(currentPost);
    });
    this.props.isPr(check);
  }

  confirmActionUpdatePRPrice(value) {
    const options = {
      title: "Title",
      message: "Message",
      buttons: [
        {
          label: "Yes",
          onClick: () => alert("Click Yes"),
        },
        {
          label: "No",
          onClick: () => alert("Click No"),
        },
      ],
      childrenElement: () => <div />,
      customUI: ({ onClose }) => (
        <div className="custom-ui-alert">
          <h1>
            Bạn đã thay đổi loại bài PR. Bạn có muốn tự động cập nhật giá?
          </h1>
          <div className="box">
            <div className="bg-d9534f" onClick={onClose}>
              Không, tôi sẽ tự thay đổi
            </div>
            <div
              className="bg-c7c6c5"
              onClick={() => {
                this.updatePRPrice(value);
                onClose();
              }}
            >
              Có, cập nhật tự động
            </div>
          </div>
        </div>
      ),
      closeOnEscape: true,
      closeOnClickOutside: true,
      willUnmount: () => {},
      onClickOutside: () => {},
      onKeypressEscape: () => {},
    };

    confirmAlert(options);
  }
  updatePRPrice = (value) => {
    const {
      post: { currentPost },
    } = this.props;
    if (currentPost.prprice != value) {
      if(this.state.timerUpdatePrice) {
        clearTimeout(this.state.timerUpdatePrice);
        this.setState({timerUpdatePrice: null});
      }
      
      const timerPrice = setTimeout(() => {
        currentPost.prprice = value;
        this.props.setCurrentPost(currentPost);
        this.props.onSelectPRType(this.state.prSelected.type, currentPost);
      }, 100);

      this.setState({timerUpdatePrice: timerPrice})
    }
  };

  confirmActionUpdatePRDiscount(value) {
    const options = {
      title: "Title",
      message: "Message",
      buttons: [
        {
          label: "Yes",
          onClick: () => alert("Click Yes"),
        },
        {
          label: "No",
          onClick: () => alert("Click No"),
        },
      ],
      childrenElement: () => <div />,
      customUI: ({ onClose }) => (
        <div className="custom-ui-alert">
          <h1>
            Bạn đã thay đổi Agency. Bạn có muốn tự động cập nhật discount?
          </h1>
          <div className="box">
            <div className="bg-d9534f" onClick={onClose}>
              Không, tôi sẽ tự thay đổi
            </div>
            <div
              className="bg-c7c6c5"
              onClick={() => {
                this.updatePRDiscount(value);
                onClose();
              }}
            >
              Có, cập nhật tự động
            </div>
          </div>
        </div>
      ),
      closeOnEscape: true,
      closeOnClickOutside: true,
      willUnmount: () => {},
      onClickOutside: () => {},
      onKeypressEscape: () => {},
    };

    confirmAlert(options);
  }

  updatePRDiscount = (value) => {
    const {
      post: { currentPost },
    } = this.props;
    if (currentPost.prdiscount != value) {
      if(this.state.timerUpdateDiscount) {
        clearTimeout(this.state.timerUpdateDiscount);
        this.setState({timerUpdateDiscount: null});
      }
      const timerDiscount = setTimeout(() => {
        this.setState({ prdiscount: value });
        currentPost.prdiscount = value;
        this.props.setCurrentPost(currentPost);
        this.updateFieldData({prdiscount: value}, "prdiscount")
        // this.props.changeFieldValue(
        //   "prdiscount",
        //   value
        // );
      }, 100);
      this.setState({timerUpdateDiscount: timerDiscount});
    }
  };
  
  componentDidUpdate(prevProps) {
    const { fields, post } = this.props;
    const { fields: prevFields, post: prevPost } = prevProps;
    if (fields && prevFields) {
      if (this.state.focusPRPrice != "onFocus" && fields.prprice !== prevFields.prprice && fields.prprice != post.currentPost.prprice) {
        this.updateFieldData(fields, "prprice");
      }
      if (this.state.focusPRDiscount != "onFocus" && fields.prdiscount !== prevFields.prdiscount && fields.prdiscount != post.currentPost.prdiscount) {
        this.updateFieldData(fields, "prdiscount");
      }
    }
    if (prevPost.currentPost.pragency != this.state.pragency) {
      // đổi agency
      this.setState({ pragency: prevPost.currentPost.pragency });

      const selectPRAgency = _.find(this.props.config.listPRAgency, {
        id: prevPost.currentPost.pragency,
      });

      if (
        selectPRAgency &&
        selectPRAgency.default_discount &&
        selectPRAgency.default_discount != this.state.prdiscount
      ) {
        this.confirmActionUpdatePRDiscount(selectPRAgency.default_discount);
      }
    }
    if (this.state.focusPRPrice != "onFocus" && prevPost.currentPost.prprice != this.state.prprice) {
      this.setState({ prprice: prevPost.currentPost.prprice });
      this.updateFieldData({prprice: prevPost.currentPost.prprice}, "prprice");
    }
  }
  updateFieldData = (data, fieldName) => {
    console.log("updateFieldData");
    if(this.state.timer){
      clearTimeout(this.state.timer);
      this.setState({timer: null})
    }
    const { post } = this.props;
    const timer = setTimeout(() => {
      post.currentPost[fieldName] = data[fieldName];
      if (fieldName && data[fieldName]) {
        const slugifyValue = data[fieldName];
        post.currentPost[fieldName] = slugifyValue;
        this.props.changeFieldValue(fieldName, slugifyValue);
      }

      if (fieldName == "prprice") {
        if (data.prprice > 0) {
          this.setState({ focusPRPrice: "is-valid" });
          this.logsChangePR("price", data.prprice);
        } else {
          this.setState({ focusPRPrice: "is-invalid" });
        }
        if(this.state.focusPRPrice != "" && this.state.focusPRPrice != "onFocus"){
          const timerNoti = setTimeout(()=>{
            this.setState({ focusPRPrice: "" });
          }, 3000);
          this.setState({timerUpdatePriceNoti: timerNoti});
        }
        
      }
      if (fieldName == "prdiscount") {
        if (data.prdiscount && (data.prdiscount < 0 || data.prdiscount > 100)) {
          this.setState({ focusPRDiscount: "is-invalid" });
        } else {
          this.setState({ focusPRDiscount: "is-valid" });
          this.logsChangePR("discount", data.prdiscount);
        }
        if(this.state.focusPRDiscount != "" && this.state.focusPRDiscount != "onFocus"){
          const timerNoti = setTimeout(()=>{
            this.setState({ focusPRDiscount: "" });
          }, 3000);
          this.setState({timerUpdateDiscountNoti: timerNoti});
        }
      }
      this.props.setCurrentPost(post.currentPost);
    }, 1000);

    this.setState({ timer });
  };

  handleChangePRAgency = (value) => {
    this.setState({pragency: value});
    if (value) {
      this.logsChangePR("agency", value.label);
    }
    else{
      // remove pr agency
      this.logsChangePR("agency", null);
    }
  }

  render() {
    const {
      layoutName,
      checkClass,
      post: { currentPost },
      isPr,
    } = this.props;
    const {pragency} = this.state;
    const _user = localStore.get('_user');
    return (
      <div className={layoutName !== "layout-pc" ? "row card" : ""}>
        {layoutName !== "layout-pc" && (
          <div className={"card-header col-12 " + checkClass}>
            <h4 className="card-title">PR</h4>
            <div className="card-tools">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="collapse"
              >
                <i className="fas fa-minus"></i>
              </button>
            </div>
          </div>
        )}
        <div className="card-body col-12">
          <Select
            defaultValue={this.state.prSelected}
            value={this.state.prSelected}
            options={this.state.prType}
            onChange={this.getValuePRType}
            placeholder="Chọn bài PR"
          />
        </div>
        {_user && _user.can_pr && this.state.prSelected.value != 0 && (
          <div className="card-body col-12">
            <CreatorItem
              creatable={false}
              checkRequireData={this.props.checkRequireData}
              functioncreate="createNewPRAgency"
              functioncall="getListPRAgency"
              newapi="/pragency"
              valueinstore="listPRAgency"
              posttype="pragency"
              type="pragency"
              selectedValue={pragency}
              setSelectedValue={this.handleChangePRAgency}
              isClearable={true}
              label="Agency"
              placeholder="Chọn Agency"
            />
            <div className="my-4">
                <Field
                    id="prpriceInput"
                    name="prprice"
                    classinput={`form-control ${this.state.focusPRPrice}`}
                    classgroup="form-group"
                    component={renderFormField}
                    format={formatPrice}
                    normalize={normalizePrice}
                    validate={validatePrice}
                    label="Giá tiền"
                    type="text"
                    onBlur={(event, newValue, previousValue, name)=>{
                      this.setState({focusPRPrice: "onBlur"})
                      this.updateFieldData({prprice: newValue}, "prprice");
                    }}
                    onFocus={(event, name)=>{
                      this.setState({focusPRPrice: "onFocus"});
                      if(this.state.timer){
                        clearTimeout(this.state.timer);
                        this.setState({timer: null})
                      }
                      if(this.state.timerUpdatePrice){
                        clearTimeout(this.state.timerUpdatePrice);
                        this.setState({timerUpdatePrice: null})
                      }
                      if(this.state.timerUpdatePriceNoti){
                        clearTimeout(this.state.timerUpdatePriceNoti);
                        this.setState({timerUpdatePriceNoti: null})
                      }
                    }}
                />
                {this.state.focusPRPrice != "" && this.state.focusPRPrice != "onFocus" && this.state.focusPRPrice != "onBlur" &&
                    <p className="blink_me">Đã cập nhật giá</p>
                }
            </div>
            <div className="my-4">
                <Field
                id="prdiscountInput"
                name="prdiscount"
                classinput={`form-control ${this.state.focusPRDiscount}`}
                classgroup="form-group"
                component={renderFormField}
                validate={validateDiscount}
                label="Giảm giá %"
                type="number"
                onBlur={(event, newValue, previousValue, name)=>{
                  this.setState({focusPRDiscount: "onBlur"})
                  this.updateFieldData({prdiscount: newValue}, "prdiscount");
                }}
                onFocus={(value)=>{
                  this.setState({focusPRDiscount: "onFocus"});
                  if(this.state.timer){
                    clearTimeout(this.state.timer);
                    this.setState({timer: null})
                  }
                  if(this.state.timerUpdateDiscount){
                    clearTimeout(this.state.timerUpdateDiscount);
                    this.setState({timerUpdateDiscount: null})
                  }
                  if(this.state.timerUpdateDiscountNoti){
                    clearTimeout(this.state.timerUpdateDiscountNoti);
                    this.setState({timerUpdateDiscountNoti: null})
                  }
                }}
                />
                {this.state.focusPRDiscount != "" && this.state.focusPRDiscount != "onFocus" && this.state.focusPRDiscount != "onBlur" &&
                    <p className="blink_me">Đã cập nhật giảm giá</p>
                }
            </div>
          </div>
        )}
      </div>
    );
  }
}
const selector = formValueSelector("formPostEdit");
PRTab = reduxForm({
  form: "formPostEdit",
  validate,
})(PRTab);

export default connect(
  (store) => {
    return {
      login: store.loginInfo,
      post: store.post,
      config: store.config,
      fileUpload: store.fileUpload,
      form: store.formPostEdit,
      fields: selector(store, "prprice", "prdiscount"),
    };
  },
  (dispatch) => {
    return {
      setCurrentPost: (value) => {
        dispatch(postActions.setCurrentPost(value));
      },
      changeFieldValue: (field, value) => {
        dispatch(change("formPostEdit", field, value));
      },
    };
  }
)(PRTab);
